import isMobileApp from './is-mobile-app';
import { getMobileAppVersion } from './env';
export default function getMobileAppRequestHeaders() {
  if (isMobileApp()) {
    const mobileAppVersion = getMobileAppVersion();
    return {
      'X-REQUESTED-WITH': 'com.upgrademobile',
      ...(mobileAppVersion ? {
        'X-UPGRADE-MOBILE-APP-VERSION': mobileAppVersion
      } : {})
    };
  }
  return {};
}